export interface ConfigurationData {
  cc: string;
  cce: string;
  ce: string;
  c: string;
  v: string;
  v1: string;
  v2: string;
  v3: string;
  v4: string;
  v5: string;
}

const ConfigurationDataInitial: ConfigurationData = {
  cc: '',
  cce: '',
  ce: '',
  c: '',
  v: '',
  v1: '',
  v2: '',
  v3: '',
  v4: '',
  v5: '',
};

export interface GlobalConfiguration {
  configuration: Array<ConfigurationData>;
}

export const GlobalConfigurationInitial = {
  configuration: [ConfigurationDataInitial],
};
